import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ArrivalStatus } from '@asset-solutions/customer-portal/orders/models';

@Component({
  selector: 'orders-arrival-status',
  host: {
    '[attr.data-arrivalStatus]': 'arrivalStatus()'
  },
  template: `
    @switch (arrivalStatus()) {
      @case ('ATRISK') {
        At risk
      }
      @case ('LATE') {
        Late
      }
      @default {
        On time
      }
    }
  `,
  styles: `
    :host {
      background-color: var(--cc-success);
      color: var(--cc-on-success);
      border-radius: 1rem;
      display: inline-block;
      padding-inline: 0.75rem;

      &[data-arrivalStatus='ATRISK'] {
        background-color: var(--cc-warning);
        color: var(--cc-on-warning);
      }

      &[data-arrivalStatus='LATE'] {
        background-color: var(--sys-error);
        color: var(--sys-on-error);
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrivalStatusComponent {
  public readonly arrivalStatus = input.required<ArrivalStatus>();
}
